import { AnimaliaListingHeroDTO } from '../../../../application/mappers/AnimaliaListingMapper';
import { animaliaListingDesignTokens } from '../shared/animalia-listing-design-tokens';
import '../hero/mv-animalia-listing-hero-stats';
import { MvAnimaliaListingHeroStats } from './mv-animalia-listing-hero-stats';

export class MvAnimaliaListingHero extends HTMLElement {
  private hero: AnimaliaListingHeroDTO | null = null;

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  setHero(hero: AnimaliaListingHeroDTO): void {
    this.hero = hero;
    this.render();
    this.attachStats();
  }

  connectedCallback(): void {
    this.render();
    this.attachStats();
  }

  private attachStats(): void {
    if (!this.shadowRoot || !this.hero) {
      return;
    }

    const statsElement = this.shadowRoot.querySelector('mv-animalia-listing-hero-stats') as
      | MvAnimaliaListingHeroStats
      | null;

    statsElement?.setStats(this.hero.stats);
  }

  private render(): void {
    if (!this.shadowRoot || !this.hero) {
      return;
    }

    this.shadowRoot.innerHTML = `
      <style>
        ${animaliaListingDesignTokens}

        section {
          border-radius: 30px;
          padding: 28px;
          background:
            linear-gradient(135deg, rgba(49, 70, 61, 0.98), rgba(95, 120, 128, 0.82)),
            linear-gradient(180deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0));
          color: #f7f3ed;
          box-shadow: 0 18px 38px rgba(31, 42, 35, 0.1);
        }

        h1 {
          margin: 8px 0 0;
          font-family: Georgia, 'Times New Roman', serif;
          line-height: 1.02;
          font-size: clamp(2.6rem, 5vw, 4.8rem);
        }
      </style>

      <section class="hero">
        <div class="hero-copy">
          <p class="section-kicker">${this.escapeHtml(this.hero.kicker)}</p>
          <h1>${this.escapeHtml(this.hero.title)}</h1>
          <mv-animalia-listing-hero-stats></mv-animalia-listing-hero-stats>
        </div>
      </section>
    `;
  }

  private escapeHtml(value: string): string {
    return value
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  }
}

if (!customElements.get('mv-animalia-listing-hero')) {
  customElements.define('mv-animalia-listing-hero', MvAnimaliaListingHero);
}
